/**
 * Brand accent contract — `html[data-brand]` and `localStorage['portal-brand-accent']`.
 * Single source for allowed ids; compare and branch using these symbols.
 */
export const BrandAccent = {
  BLUE: 'blue',
  HEALTHESUS: 'healthesus',
} as const;

export type BrandAccentId = (typeof BrandAccent)[keyof typeof BrandAccent];

export function isBrandAccentId(value: string | null | undefined): value is BrandAccentId {
  return value === BrandAccent.BLUE || value === BrandAccent.HEALTHESUS;
}

/** Default when storage is missing. */
export const DEFAULT_BRAND_ACCENT: BrandAccentId = BrandAccent.HEALTHESUS;
